import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorteDiarioModel } from '../corte-diario.models';
import * as moment from 'moment';

@Component({
  selector: 'modal-eventos',
  templateUrl: './modal-eventos.component.html',
  styleUrls: ['./modal-eventos.component.css'],
})
export class ModalEventosComponent implements OnInit {
  public titulo: string = 'Eventos';
  public esPorTipoEvento: boolean = false;
  public eventoTipo: string = '';
  public numeroGestiones: string[] = [];
  public totalGestiones: number = 0;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      // Para el caso individual
      gestionSelected: CorteDiarioModel.GetGestionesAbiertasXRutas;
      usuarioid: string;

      // Para el caso múltiple (eventos por tipo)
      esPorTipoEvento?: boolean;
      eventoTipo?: string;
      listEventos?: any[];
      listEventosCerrados?: any[];
      listEventosAbiertos?: any[];
      totalEventos?: number;
      eventosAbiertos?: number;
      eventosCerrados?: number;
    }
  ) {}

  ngOnInit(): void {
    this.inicializarModal();
  }

  private inicializarModal() {
    if (this.data.esPorTipoEvento) {
      // Caso múltiple: Eventos por tipo
      this.esPorTipoEvento = true;
      this.eventoTipo = this.data.eventoTipo || '';
      this.titulo = `Eventos de tipo: ${this.eventoTipo}`;

      // Extraer números de gestión únicos
      this.numeroGestiones = this.getNumerosGestionUnicos();
      this.totalGestiones = this.numeroGestiones.length;
    } else {
      // Caso individual: Eventos de una gestión específica
      this.esPorTipoEvento = false;
      this.titulo = `Eventos de gestión: ${this.data.gestionSelected?.NumeroGestion}`;
      this.numeroGestiones = [this.data.gestionSelected?.NumeroGestion];
      this.totalGestiones = 1;
    }
  }

  private getNumerosGestionUnicos(): string[] {
    if (!this.data.listEventos) return [];

    const numerosUnicos = new Set<string>();

    this.data.listEventos.forEach((evento) => {
      if (evento.NumeroGestion) {
        numerosUnicos.add(evento.NumeroGestion);
      }
    });

    return Array.from(numerosUnicos);
  }

  formatFecha(fecha: string): string {
    return moment(fecha).format('DD-MM-YYYY HH:mm');
  }
}
